import MyLocationIcon from "@mui/icons-material/MyLocation";
import { getLocationTypeColor } from "view/locations/utils/LocationUtils";
import Marker from "../markers/Marker";
import { LocationType } from "__generated__/enums";
import { CompactLocationFragment } from "__generated__/view/locations/graphql/location.fragments.generated";

const LocationMarker = ({
	location,
	onClick,
}: {
	location: CompactLocationFragment;
	onClick?: () => void;
}) => {
	const color = getLocationTypeColor(location.type ?? LocationType.Terminal);
	return (
		<Marker
			color={color}
			icon={<MyLocationIcon />}
			label={location.description}
			onClick={onClick} />
	);
};

export default LocationMarker;
